// extracted by mini-css-extract-plugin
export default {"dataTableFormat":"styles_dataTableFormat__S6sxa","formSpace":"styles_formSpace__k-o4v"};